{
  "app": {
    "name": "Website Guard",
    "skipToContent": "Zum Inhalt springen",
    "loading": "Wird geladen …",
    "retry": "Erneut versuchen",
    "save": "Speichern",
    "saved": "Gespeichert.",
    "cancel": "Abbrechen",
    "back": "Zurück",
    "required": "Pflichtfeld",
    "optional": "optional",
    "yes": "Ja",
    "no": "Nein"
  },
  "nav": {
    "label": "Hauptnavigation",
    "overview": "Übersicht",
    "notifications": "Benachrichtigungen",
    "account": "Konto",
    "logout": "Abmelden",
    "language": "Sprache",
    "requests": "Meine Anfragen",
    "admin": "Admin",
    "billing": "Tarif"
  },
  "lang": {
    "de": "Deutsch",
    "en": "English"
  },
  "banner": {
    "verify": "Bitte bestätigen Sie Ihre E-Mail-Adresse. Erst dann können wir Sie bei Problemen mit Ihrer Website warnen.",
    "resend": "E-Mail erneut senden",
    "sent": "Wir haben Ihnen eine neue E-Mail geschickt.",
    "openIncidents_one": "{{count}} Website ist gerade nicht erreichbar.",
    "openIncidents_other": "{{count}} Websites sind gerade nicht erreichbar."
  },
  "auth": {
    "email": "E-Mail-Adresse",
    "password": "Passwort",
    "login": {
      "title": "Anmelden",
      "submit": "Anmelden",
      "forgot": "Passwort vergessen?",
      "noAccount": "Noch kein Konto?",
      "register": "Kostenlos registrieren"
    },
    "register": {
      "title": "Kostenlos registrieren",
      "intro": "Wir prüfen Ihre Website rund um die Uhr und erklären Probleme in einfachen Worten.",
      "company": "Name Ihres Unternehmens",
      "passwordHint": "Mindestens 12 Zeichen. Am sichersten ist ein Satz, den Sie sich merken können.",
      "terms": "Ich akzeptiere die AGB und habe die Datenschutzerklärung gelesen.",
      "submit": "Konto anlegen",
      "sentTitle": "Fast geschafft",
      "sentText": "Wir haben Ihnen eine E-Mail an {{email}} geschickt. Klicken Sie auf den Link darin, um Ihr Konto zu bestätigen und sich anzumelden.",
      "haveAccount": "Sie haben schon ein Konto?"
    },
    "forgot": {
      "title": "Passwort vergessen",
      "intro": "Geben Sie Ihre E-Mail-Adresse ein. Wir schicken Ihnen einen Link, mit dem Sie ein neues Passwort festlegen.",
      "submit": "Link anfordern",
      "sent": "Wenn ein Konto zu dieser Adresse existiert, haben wir Ihnen gerade einen Link geschickt. Er ist eine Stunde gültig."
    },
    "reset": {
      "title": "Neues Passwort festlegen",
      "password": "Neues Passwort",
      "submit": "Passwort speichern",
      "done": "Ihr Passwort wurde geändert. Bitte melden Sie sich neu an.",
      "toLogin": "Zur Anmeldung"
    },
    "verify": {
      "title": "E-Mail-Adresse bestätigen",
      "checking": "Wir bestätigen Ihre E-Mail-Adresse …",
      "success": "Danke! Ihre E-Mail-Adresse ist bestätigt.",
      "toOverview": "Zur Übersicht",
      "missingToken": "Der Link ist unvollständig. Bitte öffnen Sie den Link aus der E-Mail erneut."
    }
  },
  "errors": {
    "VALIDATION_FAILED": "Bitte prüfen Sie Ihre Eingaben.",
    "INVALID_CREDENTIALS": "E-Mail-Adresse oder Passwort stimmen nicht.",
    "WEAK_PASSWORD": "Dieses Passwort ist zu unsicher.",
    "weakPassword": {
      "too_short": "Das Passwort ist zu kurz (mindestens 12 Zeichen).",
      "too_long": "Das Passwort ist zu lang (höchstens 128 Zeichen).",
      "common": "Dieses Passwort ist sehr verbreitet und leicht zu erraten.",
      "contains_email": "Das Passwort darf Ihre E-Mail-Adresse nicht enthalten."
    },
    "TOKEN_INVALID": "Dieser Link ist ungültig oder wurde schon verwendet.",
    "TOKEN_EXPIRED": "Dieser Link ist abgelaufen. Bitte fordern Sie einen neuen an.",
    "RATE_LIMITED": "Zu viele Versuche. Bitte warten Sie einen Moment.",
    "URL_NOT_ALLOWED": "Diese Adresse können wir nicht prüfen. Bitte geben Sie die öffentliche Adresse Ihrer Website ein, z. B. meine-firma.de.",
    "CONFLICT": "Das gibt es schon.",
    "PLAN_LIMIT_REACHED": "Ihr Tarif ist ausgeschöpft.",
    "EMAIL_NOT_VERIFIED": "Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse.",
    "NOT_FOUND": "Nicht gefunden.",
    "UNAUTHENTICATED": "Bitte melden Sie sich an.",
    "NETWORK": "Keine Verbindung zum Server. Bitte prüfen Sie Ihre Internetverbindung.",
    "INTERNAL": "Da ist bei uns etwas schiefgegangen. Bitte versuchen Sie es gleich noch einmal.",
    "required": "Bitte füllen Sie dieses Feld aus.",
    "email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "terms": "Bitte akzeptieren Sie die AGB.",
    "FORBIDDEN": "Diese Aktion ist nicht erlaubt.",
    "CAPTCHA_REQUIRED": "Bitte bestätigen Sie, dass Sie ein Mensch sind.",
    "NOT_VERIFIED": "Die Inhaberschaft konnte noch nicht bestätigt werden."
  },
  "status": {
    "up": "Online",
    "down": "Offline",
    "suspect": "Wird geprüft",
    "degraded": "Langsam",
    "paused": "Pausiert",
    "unknown": "Noch nicht geprüft"
  },
  "severity": {
    "critical": "Kritisch",
    "high": "Hoch",
    "medium": "Mittel",
    "low": "Niedrig",
    "info": "Hinweis"
  },
  "overview": {
    "title": "Übersicht",
    "add": "Website hinzufügen",
    "empty": "Sie überwachen noch keine Website.",
    "emptyText": "Fügen Sie Ihre erste Website hinzu – in etwa einer Minute sehen Sie die ersten Ergebnisse.",
    "uptime30d": "Erreichbarkeit (30 Tage)",
    "noData": "noch keine Daten",
    "problems": "Offene Probleme",
    "noProblems": "Keine offenen Probleme",
    "open": "Details zu {{name}}"
  },
  "addSite": {
    "title": "Website hinzufügen",
    "intro": "Geben Sie die Adresse Ihrer Website ein. Wir prüfen sie danach automatisch – Sie müssen nichts installieren.",
    "url": "Adresse der Website",
    "urlHint": "z. B. meine-firma.de",
    "name": "Anzeigename",
    "nameHint": "So erscheint die Website in Ihrer Übersicht und in E-Mails.",
    "submit": "Website hinzufügen",
    "checking": "Wir rufen Ihre Website auf …",
    "limit": "Ihr Tarif erlaubt {{max}} Website(s). Mit einem Upgrade können Sie weitere überwachen.",
    "exists": "Diese Website überwachen Sie bereits.",
    "unreachable": "Wir haben die Website hinzugefügt, konnten sie aber gerade nicht erreichen. Wir prüfen weiter und melden uns, falls sie länger ausfällt."
  },
  "site": {
    "back": "Zur Übersicht",
    "lastCheck": "Zuletzt geprüft: {{time}}",
    "notChecked": "Die ersten Prüfungen laufen gerade – das dauert etwa eine Minute.",
    "responseTime": "Antwortzeit",
    "incidentsLink": "Alle Ausfälle",
    "openIncident": "Ihre Website ist seit {{time}} nicht erreichbar.",
    "tiles": {
      "label": "Bereiche",
      "availability": "Erreichbarkeit",
      "security": "Sicherheit",
      "links": "Links",
      "seo": "Google-Auffindbarkeit",
      "performance": "Geschwindigkeit",
      "email": "E-Mail",
      "compliance": "Rechtliches"
    },
    "chart": {
      "title": "Erreichbarkeit und Antwortzeit",
      "range": "Zeitraum",
      "ranges": {
        "24h": "24 Stunden",
        "7d": "7 Tage",
        "30d": "30 Tage"
      },
      "uptime": "Erreichbar: {{value}} %",
      "empty": "Für diesen Zeitraum liegen noch keine Messungen vor.",
      "description": "Balkendiagramm der Antwortzeiten. Rot markierte Zeiträume enthalten fehlgeschlagene Prüfungen.",
      "point": "{{time}}: {{ms}} ms, {{failed}} von {{checks}} Prüfungen fehlgeschlagen",
      "retention": "Rohdaten werden 14 Tage aufbewahrt."
    },
    "top": {
      "title": "Was jetzt wichtig ist",
      "empty": "Aktuell gibt es nichts zu tun. Wir melden uns, sobald uns etwas auffällt."
    }
  },
  "incidents": {
    "title": "Ausfälle",
    "empty": "Keine Ausfälle aufgezeichnet.",
    "filter": "Anzeigen",
    "filters": {
      "all": "Alle",
      "open": "Laufend",
      "resolved": "Behoben"
    },
    "start": "Beginn",
    "duration": "Dauer",
    "cause": "Ursache",
    "state": "Status",
    "ongoing": "Läuft noch",
    "resolved": "Behoben",
    "unstable": "instabil",
    "confidence": "Geprüft von 1 Standort (Deutschland). Ein Standort kann einen weltweiten Ausfall nicht beweisen.",
    "kinds": {
      "downtime": "Nicht erreichbar",
      "degraded": "Langsam",
      "keyword_missing": "Inhalt fehlt",
      "ssl_expired": "SSL abgelaufen",
      "ssl_invalid": "SSL ungültig",
      "domain_expired": "Domain abgelaufen",
      "dns_failure": "DNS-Fehler"
    },
    "causes": {
      "TIMEOUT": "Server antwortet nicht",
      "CONN_REFUSED": "Verbindung abgelehnt",
      "CONN_RESET": "Verbindung abgebrochen",
      "DNS_NXDOMAIN": "Domain nicht gefunden",
      "DNS_SERVFAIL": "Nameserver-Fehler",
      "TLS_ERROR": "SSL-Fehler",
      "TOO_MANY_REDIRECTS": "Endlose Weiterleitung",
      "HTTP_5XX": "Serverfehler",
      "HTTP_4XX": "Seite nicht abrufbar",
      "HTTP_UNEXPECTED": "Unerwartete Antwort",
      "CMS_FATAL": "Technische Fehlermeldung",
      "CMS_MAINTENANCE": "Wartungsmodus",
      "SLOW": "Langsame Antwort",
      "KEYWORD_MISSING": "Text fehlt",
      "KEYWORD_FOUND": "Unerwarteter Text",
      "SSL_EXPIRED": "Zertifikat abgelaufen",
      "SSL_SELF_SIGNED": "Zertifikat nicht vertrauenswürdig",
      "SSL_HOSTNAME_MISMATCH": "Zertifikat für andere Adresse",
      "DOMAIN_EXPIRED": "Domain abgelaufen",
      "fallback": "Unbekannte Ursache"
    }
  },
  "notifications": {
    "title": "Benachrichtigungen",
    "prefsTitle": "Wann wir Sie benachrichtigen",
    "downAlert": "Wenn meine Website nicht erreichbar ist",
    "recoveryAlert": "Wenn sie wieder erreichbar ist",
    "degradedAlert": "Wenn sie auffällig langsam ist",
    "minDowntime": "Nur bei Ausfällen ab",
    "minDowntimeOptions": {
      "0": "sofort (nach 3 Prüfungen)",
      "1": "1 Minute",
      "2": "2 Minuten",
      "5": "5 Minuten",
      "10": "10 Minuten"
    },
    "reminder": "Erinnerung, solange die Website nicht erreichbar ist",
    "reminderOptions": {
      "0": "keine Erinnerung",
      "6": "alle 6 Stunden",
      "12": "alle 12 Stunden",
      "24": "alle 24 Stunden",
      "48": "alle 48 Stunden"
    },
    "weeklyDigest": "Wöchentliche Zusammenfassung (montags)",
    "monthlyReport": "Monatsbericht (am 1. des Monats)",
    "recipientsTitle": "Empfänger",
    "recipientsIntro": "Weitere Adressen erhalten erst Nachrichten, wenn sie den Link in unserer Bestätigungs-E-Mail angeklickt haben.",
    "limit": "{{count}} von {{max}} Empfängern",
    "you": "Sie",
    "pending": "Wartet auf Bestätigung",
    "confirmed": "Bestätigt",
    "active": "Aktiv",
    "test": "Testnachricht senden",
    "testSent": "Testnachricht an {{target}} ist unterwegs.",
    "remove": "Entfernen",
    "removeConfirm": "{{target}} wirklich entfernen?",
    "addTitle": "Empfänger hinzufügen",
    "addEmail": "E-Mail-Adresse",
    "add": "Hinzufügen",
    "added": "Wir haben {{target}} eine Bestätigungs-E-Mail geschickt.",
    "limitReached": "Ihr Tarif erlaubt {{max}} Empfänger."
  },
  "account": {
    "title": "Konto",
    "profile": "Ihre Daten",
    "fullName": "Ihr Name",
    "company": "Unternehmen",
    "companyName": "Name des Unternehmens",
    "timezone": "Zeitzone",
    "language": "Sprache der App und der E-Mails",
    "businessType": "Art Ihres Geschäfts",
    "businessTypes": {
      "none": "keine Angabe",
      "b2c_shop": "Online-Shop für Privatkunden",
      "b2c_services": "Dienstleistung für Privatkunden",
      "b2b": "Geschäftskunden",
      "info_only": "Nur Informationsseite"
    },
    "companySize": "Größe",
    "companySizes": {
      "none": "keine Angabe",
      "solo": "nur ich",
      "micro": "2–9 Personen",
      "small": "10–49 Personen",
      "medium": "50–249 Personen"
    },
    "passwordTitle": "Passwort ändern",
    "currentPassword": "Aktuelles Passwort",
    "newPassword": "Neues Passwort",
    "changePassword": "Passwort ändern",
    "passwordChanged": "Ihr Passwort wurde geändert. Andere Geräte wurden abgemeldet."
  },
  "confirmRecipient": {
    "title": "Empfänger bestätigen",
    "checking": "Wir bestätigen Ihre Adresse …",
    "success": "Danke! {{target}} erhält ab jetzt Nachrichten zu den Websites von {{account}}."
  },
  "notFound": {
    "title": "Seite nicht gefunden",
    "text": "Diese Seite gibt es nicht.",
    "home": "Zur Startseite"
  },
  "siteNav": {
    "label": "Bereiche der Website",
    "overview": "Übersicht",
    "findings": "Probleme",
    "incidents": "Ausfälle",
    "links": "Links",
    "speed": "Geschwindigkeit",
    "settings": "Einstellungen"
  },
  "health": {
    "title": "Health Score",
    "gradeSr": "Note {{grade}}",
    "trendUp": "+{{points}} Punkte in 7 Tagen",
    "trendDown": "−{{points}} Punkte in 7 Tagen",
    "trendSame": "Unverändert gegenüber vor 7 Tagen",
    "pending": "Die Bewertung erscheint, sobald die ersten Prüfungen abgeschlossen sind."
  },
  "tileStatus": {
    "good": "In Ordnung",
    "warn": "Hinweise",
    "bad": "Handlungsbedarf",
    "unknown": "Noch offen"
  },
  "help": {
    "cta": "Hilfe anfordern ({{price}})",
    "ctaFrom": "Hilfe anfordern (ab {{price}})",
    "title": "Hilfe anfordern"
  },
  "scan": {
    "unverified": "Bitte bestätigen Sie zuerst, dass die Website Ihnen gehört.",
    "limit": "Das Tageslimit für manuelle Prüfungen Ihres Tarifs ist erreicht. Morgen geht es wieder.",
    "toSettings": "Zu den Einstellungen"
  },
  "onboarding": {
    "title": "Wir prüfen Ihre Website",
    "running": "Die ersten Prüfungen laufen …",
    "finished": "Die ersten Prüfungen sind fertig",
    "progress": "{{done}} von {{total}} Prüfungen abgeschlossen",
    "progressLabel": "Fortschritt der Prüfungen",
    "steps": {
      "availability": "Erreichbarkeit",
      "ssl": "SSL-Zertifikat",
      "domain": "Domain",
      "seo": "Startseite und Google-Auffindbarkeit",
      "links": "Links (bis zu 25 Seiten)",
      "performance": "Geschwindigkeit",
      "email": "E-Mail-Einstellungen"
    },
    "status": {
      "pending": "wartet",
      "running": "läuft",
      "done": "fertig",
      "failed": "nicht möglich"
    },
    "result": "Ihr Ergebnis",
    "scoring": "Die Bewertung wird gerade berechnet …",
    "toDashboard": "Zur Website-Übersicht",
    "allFindings": "Alle Probleme ansehen",
    "canLeave": "Sie können diese Seite verlassen – die Prüfungen laufen weiter."
  },
  "findings": {
    "title": "Probleme",
    "wholeSite": "Gesamte Website",
    "ignore": "Ignorieren",
    "restore": "Zurückholen",
    "ignoreReason": "Warum ignorieren?",
    "ignoreConfirm": "Ignorieren bestätigen",
    "reasons": {
      "not_relevant": "Für mich nicht relevant",
      "will_fix_later": "Erledige ich später",
      "false_positive": "Fehlalarm"
    },
    "count_one": "{{count}} Stelle",
    "count_other": "{{count}} Stellen",
    "since": "Seit {{date}}",
    "what": "Was ist los?",
    "impact": "Warum ist das wichtig?",
    "action": "Was ist zu tun?",
    "diy": "Anleitung zum Selbermachen",
    "affected": "Betroffen",
    "more_one": "und {{count}} weitere Stelle",
    "more_other": "und {{count}} weitere Stellen",
    "filters": {
      "status": "Status",
      "category": "Bereich",
      "severity": "Dringlichkeit",
      "all": "Alle"
    },
    "statuses": {
      "open": "Offen",
      "ignored": "Ignoriert",
      "resolved": "Behoben"
    },
    "empty": {
      "open": "Keine offenen Probleme – sehr gut!",
      "ignored": "Sie haben keine Probleme ignoriert.",
      "resolved": "Noch keine behobenen Probleme."
    }
  },
  "links": {
    "title": "Links",
    "recheck": "Jetzt neu prüfen",
    "running": "Die Prüfung läuft. Das kann einige Minuten dauern.",
    "none": "Die Links wurden noch nicht geprüft.",
    "checkedAt": "Geprüft am",
    "pages": "Seiten",
    "links": "Links",
    "scanStatus": {
      "partial": "Die Prüfung wurde nicht vollständig abgeschlossen.",
      "failed": "Die Prüfung ist fehlgeschlagen.",
      "queued": "Wartet auf den Start.",
      "running": "Läuft."
    },
    "noBroken": "Keine defekten Links gefunden.",
    "broken_one": "{{count}} defekter Link",
    "broken_other": "{{count}} defekte Links",
    "status": "Fehler {{status}}",
    "errors": {
      "unknown": "Nicht erreichbar",
      "DNS_NXDOMAIN": "Domain existiert nicht",
      "DNS_SERVFAIL": "DNS-Fehler",
      "TIMEOUT": "Keine Antwort (Zeitüberschreitung)",
      "CONN_REFUSED": "Verbindung abgelehnt",
      "CONN_RESET": "Verbindung abgebrochen",
      "TLS_ERROR": "Fehler beim sicheren Verbindungsaufbau",
      "TOO_MANY_REDIRECTS": "Zu viele Weiterleitungen",
      "BODY_TOO_LARGE": "Antwort zu groß",
      "PROTOCOL_ERROR": "Ungültige Antwort",
      "URL_NOT_ALLOWED": "Adresse wird nicht geprüft"
    },
    "kinds": {
      "a": "Link",
      "img": "Bild",
      "script": "Skript",
      "css": "Stylesheet",
      "iframe": "Eingebettete Seite"
    },
    "internal": "intern",
    "external": "extern",
    "foundOn": "Gefunden auf",
    "anchor": "(Linktext: „{{text}}“)"
  },
  "speed": {
    "title": "Geschwindigkeit",
    "measure": "Jetzt messen",
    "running": "Die Messung läuft. Das dauert etwa eine Minute.",
    "none": "Noch keine Messung vorhanden.",
    "strategy": {
      "mobile": "Smartphone",
      "desktop": "Computer"
    },
    "measuredAt": "gemessen am {{time}}",
    "fieldData": "Daten echter Besucher",
    "labData": "Labormessung",
    "score": "Punktzahl",
    "lcp": "Hauptinhalt sichtbar (LCP)",
    "inp": "Reaktion auf Eingaben (INP)",
    "tbt": "Blockierzeit (TBT)",
    "cls": "Layout-Verschiebung (CLS)",
    "ttfb": "Serverantwort (TTFB)",
    "weight": "Seitengröße",
    "opportunities": "Größte Einsparmöglichkeiten",
    "saves": "spart ca. {{value}}",
    "audits": {
      "render-blocking-resources": "Blockierende CSS- und JavaScript-Dateien",
      "unused-css-rules": "Ungenutztes CSS entfernen",
      "unused-javascript": "Ungenutztes JavaScript entfernen",
      "uses-optimized-images": "Bilder komprimieren",
      "modern-image-formats": "Bilder in modernen Formaten (WebP, AVIF)",
      "uses-responsive-images": "Bilder in passender Größe ausliefern",
      "offscreen-images": "Bilder außerhalb des Sichtbereichs später laden",
      "uses-text-compression": "Textkomprimierung aktivieren (gzip/Brotli)",
      "server-response-time": "Server antwortet langsam",
      "unminified-css": "CSS verkleinern",
      "unminified-javascript": "JavaScript verkleinern",
      "efficient-animated-content": "Videos statt animierter GIFs",
      "redirects": "Weiterleitungen vermeiden",
      "legacy-javascript": "Veraltetes JavaScript vermeiden",
      "uses-rel-preconnect": "Frühe Verbindungen zu wichtigen Servern"
    },
    "errors": {
      "PSI_NOT_CONFIGURED": "Die Geschwindigkeitsmessung ist noch nicht eingerichtet.",
      "PSI_QUOTA": "Der Messdienst ist gerade ausgelastet. Wir versuchen es später erneut.",
      "PSI_TIMEOUT": "Die Messung hat zu lange gedauert. Wir versuchen es später erneut.",
      "other": "Die letzte Messung ist fehlgeschlagen."
    },
    "source": "Gemessen mit Google PageSpeed Insights. Grün: gut, gelb: verbesserungswürdig, rot: schlecht."
  },
  "settings": {
    "title": "Einstellungen",
    "general": "Allgemein",
    "name": "Name der Website",
    "monitoring": "Überwachung",
    "interval": "Prüfintervall der Erreichbarkeit",
    "intervalHint": "Kürzere Intervalle hängen von Ihrem Tarif ab.",
    "minutes_one": "jede Minute",
    "minutes_other": "alle {{count}} Minuten",
    "hours_one": "jede Stunde",
    "hours_other": "alle {{count}} Stunden",
    "pausedText": "Die Überwachung ist pausiert. Wir prüfen nichts und senden keine Warnungen.",
    "activeText": "Die Überwachung ist aktiv.",
    "pause": "Überwachung pausieren",
    "resume": "Überwachung fortsetzen",
    "keywords": {
      "title": "Schlüsselwort-Prüfung",
      "intro": "Wir melden uns, wenn ein bestimmter Text auf einer Seite fehlt – oder auftaucht (z. B. „Wartungsmodus“).",
      "limit": "Ihr Tarif erlaubt {{max}} Schlüsselwort-Prüfung(en) pro Website.",
      "modes": {
        "present": "muss vorhanden sein",
        "absent": "darf nicht vorkommen"
      },
      "remove": "Entfernen",
      "removeLabel": "Prüfung „{{keyword}}“ entfernen",
      "keyword": "Schlüsselwort",
      "url": "Seite",
      "urlHint": "Leer lassen für die Startseite.",
      "mode": "Bedingung",
      "caseSensitive": "Groß- und Kleinschreibung beachten",
      "add": "Prüfung hinzufügen",
      "notInPlan": "Schlüsselwort-Prüfungen sind ab dem Tarif Starter enthalten."
    },
    "verification": {
      "title": "Inhaberschaft bestätigen",
      "done": "Sie haben bestätigt, dass die Website Ihnen gehört.",
      "missing": "Noch nicht bestätigt. Ohne Bestätigung prüfen wir höchstens 25 Seiten und Sie können die Link-Prüfung nicht selbst starten. Die Bestätigung dauert etwa 5 Minuten."
    },
    "delete": {
      "title": "Website entfernen",
      "text": "Alle Prüfungen, Probleme und Verläufe dieser Website werden gelöscht.",
      "button": "Website entfernen",
      "confirm": "„{{name}}“ endgültig entfernen"
    }
  },
  "price": {
    "fixed": "{{price}}",
    "from": "ab {{price}}",
    "hourly": "{{price}}/Std.",
    "monthly": "ab {{price}}/Monat"
  },
  "request": {
    "service": "Leistung",
    "general": "Allgemeine Anfrage (Preis nach Absprache)",
    "discount": "Inklusive {{pct}} % Rabatt Ihres Tarifs (Listenpreis {{list}}).",
    "net": "Preis zzgl. MwSt. Wir beginnen erst, wenn Sie unserem Angebot zugestimmt haben.",
    "message": "Ihre Nachricht",
    "contact": "Wie sollen wir Sie erreichen?",
    "contactBy": {
      "email": "Per E-Mail",
      "phone": "Per Telefon"
    },
    "phone": "Telefonnummer",
    "phoneInvalid": "Bitte geben Sie eine gültige Telefonnummer ein.",
    "name": "Ihr Name",
    "consent": "Ich bin einverstanden, dass Sie mich zu dieser Anfrage kontaktieren.",
    "consentRequired": "Bitte bestätigen Sie, dass wir Sie kontaktieren dürfen.",
    "submit": "Anfrage senden",
    "sent": "Wir haben Ihre Anfrage erhalten.",
    "sentText": "Wir melden uns innerhalb von 1 Werktag. Eine Bestätigung ist per E-Mail unterwegs.",
    "toList": "Meine Anfragen ansehen",
    "close": "Schließen",
    "limit": "Sie haben heute schon viele Anfragen gesendet. Bitte versuchen Sie es morgen wieder."
  },
  "requests": {
    "title": "Meine Anfragen",
    "intro": "Hier sehen Sie, was Sie bei uns angefragt haben und wie weit wir sind.",
    "empty": "Sie haben noch keine Hilfe angefordert. Bei jedem Problem finden Sie die Schaltfläche „Hilfe anfordern“.",
    "cancel": "Anfrage zurückziehen",
    "quote": "Angebot: {{price}} zzgl. MwSt.",
    "status": {
      "new": "Eingegangen",
      "contacted": "In Kontakt",
      "quoted": "Angebot gesendet",
      "won": "Beauftragt",
      "lost": "Nicht beauftragt",
      "cancelled": "Zurückgezogen"
    },
    "explain": {
      "new": "Wir melden uns innerhalb von 1 Werktag.",
      "contacted": "Wir haben Sie kontaktiert.",
      "quoted": "Wir haben Ihnen ein Angebot geschickt.",
      "won": "Vielen Dank für Ihren Auftrag.",
      "lost": "Diese Anfrage ist abgeschlossen.",
      "cancelled": "Sie haben diese Anfrage zurückgezogen."
    }
  },
  "admin": {
    "title": "Admin-Bereich",
    "nav": "Admin-Bereiche",
    "noAccess": "Dieser Bereich ist nur für Betreiber.",
    "tabs": {
      "accounts": "Konten",
      "requests": "Anfragen",
      "services": "Leistungen",
      "system": "System"
    },
    "mfa": {
      "setupTitle": "Zweiten Faktor einrichten",
      "setupText": "Für den Admin-Bereich brauchen Sie eine Authenticator-App (z. B. Google Authenticator, Aegis oder 1Password).",
      "start": "Einrichtung starten",
      "secret": "Geben Sie diesen Schlüssel in Ihrer App ein oder öffnen Sie den Link auf Ihrem Telefon:",
      "openApp": "In der Authenticator-App öffnen",
      "code": "6-stelliger Code",
      "enable": "Aktivieren",
      "verifyTitle": "Code bestätigen",
      "verifyText": "Bitte geben Sie den aktuellen Code aus Ihrer Authenticator-App ein.",
      "verify": "Bestätigen"
    },
    "plans": {
      "free": "Free",
      "starter": "Starter",
      "business": "Business",
      "agency": "Agentur"
    },
    "accounts": {
      "search": "Suche",
      "searchHint": "E-Mail, Domain oder Firmenname",
      "find": "Suchen",
      "none": "Keine Konten gefunden.",
      "sites_one": "{{count}} Website",
      "sites_other": "{{count}} Websites",
      "open_one": "{{count}} offene Anfrage",
      "open_other": "{{count}} offene Anfragen",
      "deleted": "gelöscht",
      "plan": "Tarif",
      "since": "Kunde seit",
      "zone": "Zeitzone und Sprache",
      "readOnly": "Kundendaten sind hier nur lesbar. Ändern können Sie nur Anfragen.",
      "users": "Benutzer",
      "unverified": "E-Mail nicht bestätigt",
      "siteList": "Websites",
      "noSites": "Keine Websites.",
      "verified": "bestätigt"
    },
    "requests": {
      "filter": "Status",
      "none": "Keine Anfragen.",
      "status": "Status",
      "assigned": "Zuständig",
      "quoted": "Angebotspreis (€ netto)",
      "won": "Auftragswert (€ netto)",
      "notes": "Interne Notizen (nur für Betreiber)",
      "mailHint": "Wechsel auf „In Kontakt“, „Angebot gesendet“ oder „Beauftragt“ schickt dem Kunden eine E-Mail.",
      "history": "Verlauf",
      "noHistory": "Noch keine Änderungen.",
      "account": "Konto",
      "email": "E-Mail",
      "name": "Name",
      "phone": "Telefon",
      "contactBy": "Kontakt per",
      "site": "Website",
      "shownPrice": "Angezeigter Preis",
      "created": "Eingegangen"
    },
    "services": {
      "intro": "Preise netto in Euro. Inaktive Leistungen werden Kunden nicht angeboten.",
      "inactive": "inaktiv",
      "edit": "Bearbeiten",
      "nameDe": "Name (DE)",
      "nameEn": "Name (EN)",
      "descriptionDe": "Beschreibung (DE)",
      "descriptionEn": "Beschreibung (EN)",
      "price": "Preis (€ netto)",
      "priceType": "Preisart",
      "priceTypes": {
        "fixed": "Festpreis",
        "from": "ab-Preis",
        "hourly": "pro Stunde",
        "monthly": "monatlich"
      },
      "sort": "Reihenfolge",
      "rules": "Zugehörige Regeln (z. B. SSL_*)",
      "active": "Aktiv"
    },
    "system": {
      "ok": "Kein Auslöser für den Umzug auf VPS-3 aktiv.",
      "breached_one": "{{count}} Auslöser für den Umzug auf VPS-3 aktiv.",
      "breached_other": "{{count}} Auslöser für den Umzug auf VPS-3 aktiv.",
      "server": "Server",
      "metrics": {
        "rss": "Speicher Worker",
        "ram": "RAM frei",
        "load": "Load (1 Min.)",
        "disk": "Festplatte belegt",
        "lag": "Scheduler-Verzug p95",
        "monitors": "Aktive Monitore",
        "sites": "Aktive Websites",
        "smtp": "Mail-Fehler 24 h",
        "psi": "PSI-Fehler 24 h"
      },
      "workerSeen": "Letzte Meldung des Workers: {{time}}",
      "workerMissing": "Der Worker hat in der letzten Stunde keine Werte gemeldet.",
      "triggers": "Auslöser VPS-3",
      "trigger": {
        "ram_available_mb": "RAM frei unter {{threshold}} MB",
        "load1": "Load über {{threshold}}",
        "scheduler_lag_p95_ms": "Scheduler-Verzug p95 über {{threshold}} ms",
        "crawl_queue_oldest_h": "Crawl-Warteschlange älter als {{threshold}} Std.",
        "monitors_active": "Mehr als {{threshold}} aktive Monitore",
        "disk_used_pct": "Festplatte über {{threshold}} %"
      },
      "queues": "Warteschlangen",
      "queue": {
        "crawl": "Crawl",
        "performance": "Geschwindigkeit",
        "seo_home": "Startseite",
        "mail": "E-Mail"
      },
      "queueLine": "{{pending}} wartend, {{active}} aktiv, {{failed}} Fehler (24 h)"
    }
  },
  "quickCheck": {
    "title": "Kostenloser Website-Check",
    "intro": "Wir prüfen Ihre Startseite und bis zu 10 Unterseiten: Erreichbarkeit, Sicherheit, Google-Auffindbarkeit, Geschwindigkeit und Rechtliches. Das dauert etwa eine Minute.",
    "submit": "Website prüfen",
    "privacy": "Wir speichern die Adresse und das Ergebnis 90 Tage. Ohne Ihre Zustimmung schicken wir Ihnen nichts.",
    "captcha": "Bitte bestätigen Sie kurz, dass Sie ein Mensch sind:",
    "limit": "Sie haben in der letzten Stunde schon mehrere Websites geprüft. Bitte versuchen Sie es später wieder.",
    "runningTitle": "Wir prüfen {{host}} …",
    "running": "Das dauert etwa eine Minute. Sie können diese Seite offen lassen.",
    "failed": "Die Prüfung ist leider fehlgeschlagen.",
    "again": "Noch einmal prüfen",
    "resultTitle": "Ergebnis für {{host}}",
    "unreachable": "Ihre Website war während der Prüfung nicht erreichbar.",
    "areas": "Bereiche",
    "pending": "wird nachgeladen …",
    "top": "Die wichtigsten Punkte",
    "noProblems": "Wir haben keine Probleme gefunden – sehr gut!",
    "more_one": "…und {{count}} weiteres Problem. Registrieren Sie sich kostenlos, um alle zu sehen.",
    "more_other": "…und {{count}} weitere Probleme. Registrieren Sie sich kostenlos, um alle zu sehen.",
    "cta": "Kostenlos überwachen lassen",
    "ctaText": "Wir prüfen Ihre Website dann rund um die Uhr und melden uns, wenn etwas nicht stimmt. Keine Kreditkarte nötig.",
    "emailTitle": "Ergebnis per E-Mail",
    "emailSubmit": "Ergebnis zusenden",
    "consent": "Ja, schicken Sie mir das Ergebnis per E-Mail. Ich bestätige das über einen Link.",
    "consentRequired": "Bitte stimmen Sie zu, damit wir Ihnen die E-Mail senden dürfen.",
    "emailSent": "Fast geschafft: Bitte bestätigen Sie den Link, den wir an {{email}} geschickt haben.",
    "confirmTitle": "E-Mail bestätigen",
    "confirmed": "Danke! Das Ergebnis ist auf dem Weg in Ihr Postfach.",
    "toResult": "Zum Ergebnis"
  },
  "billing": {
    "title": "Tarif & Rechnungen",
    "yourPlan": "Ihr Tarif",
    "trial_one": "Business-Test: noch {{count}} Tag (bis {{date}}). Danach geht es kostenlos im Free-Tarif weiter.",
    "trial_other": "Business-Test: noch {{count}} Tage (bis {{date}}). Danach geht es kostenlos im Free-Tarif weiter.",
    "renewsOn": "verlängert sich am {{date}}",
    "endsOn": "endet am {{date}}",
    "usageSites": "Aktive Websites",
    "usageRecipients": "Empfänger",
    "portal": "Rechnungen & Zahlungsdaten",
    "compare": "Tarife vergleichen",
    "intervalLabel": "Abrechnung",
    "intervals": {
      "month": "Monatlich",
      "year": "Jährlich"
    },
    "per": {
      "month": "Monat",
      "year": "Jahr"
    },
    "net": "zzgl. MwSt.",
    "current": "Ihr aktueller Tarif",
    "choose": "Tarif wählen",
    "changeInPortal": "Tarif wechseln oder kündigen können Sie unter „Rechnungen & Zahlungsdaten“.",
    "minutes_one": "jede Minute",
    "minutes_other": "alle {{count}} Min.",
    "days_one": "{{count}} Tag",
    "days_other": "{{count}} Tage",
    "rows": {
      "sites": "Websites",
      "interval": "Prüfintervall",
      "pages": "Seiten je Link-Prüfung",
      "recipients": "E-Mail-Empfänger",
      "keywords": "Schlüsselwort-Prüfungen",
      "digest": "Wochenbericht",
      "history": "Verlauf",
      "discount": "Rabatt auf Leistungen"
    },
    "thanks": "Vielen Dank! Ihr neuer Tarif ist aktiv.",
    "activating": "Zahlung erhalten – wir schalten Ihren Tarif gerade frei …",
    "cancelled": "Der Kauf wurde abgebrochen. Es wurde nichts berechnet.",
    "pastDue": "Ihre letzte Zahlung ist fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsdaten, sonst wechseln wir nach 14 Tagen in den Free-Tarif.",
    "unavailable": "Die Online-Zahlung ist noch nicht eingerichtet.",
    "activeTitle": "Welche Websites sollen aktiv bleiben?",
    "activeText": "Ihr Tarif umfasst {{max}} Website(s). Die anderen pausieren wir – es werden keine Daten gelöscht.",
    "pausedByPlan": "pausiert (Tarif)",
    "activeSave": "Auswahl speichern"
  },
  "verify": {
    "method": "Wie möchten Sie bestätigen?",
    "methods": {
      "meta_tag": {
        "title": "Meta-Tag auf der Startseite",
        "text": "Am einfachsten mit WordPress, Jimdo und anderen Baukästen.",
        "step": "Fügen Sie diesen Code in den <head>-Bereich Ihrer Startseite ein:"
      },
      "dns_txt": {
        "title": "DNS-Eintrag (TXT)",
        "text": "Beim Domain-Anbieter (z. B. IONOS, Strato, All-Inkl). Kann bis zu einige Stunden dauern.",
        "step": "Legen Sie bei Ihrem Domain-Anbieter diesen TXT-Eintrag an:"
      },
      "file": {
        "title": "Datei auf dem Server",
        "text": "Wenn Sie per FTP auf Ihre Website zugreifen können.",
        "step": "Legen Sie diese Datei auf Ihrem Server an:"
      }
    },
    "createCode": "Code erzeugen",
    "newCode": "Neuen Code erzeugen",
    "dnsName": "Name (Host)",
    "dnsValue": "Wert",
    "metaTag": "Meta-Tag",
    "filePath": "Pfad",
    "fileContent": "Inhalt der Datei",
    "copy": "Kopieren",
    "copied": "Kopiert",
    "copyLabel": "{{label}} kopieren",
    "validUntil": "Der Code gilt bis {{date}}. Sie können den Eintrag nach der Bestätigung stehen lassen.",
    "activeCode": "Es gibt einen Code ({{method}}, gültig bis {{date}}). Haben Sie ihn nicht mehr? Erzeugen Sie einfach einen neuen.",
    "check": "Jetzt prüfen",
    "hints": {
      "dns_missing": "Wir finden noch keinen TXT-Eintrag. DNS-Änderungen brauchen oft 10 Minuten bis einige Stunden – bitte später erneut prüfen.",
      "dns_mismatch": "Es gibt einen TXT-Eintrag, aber mit einem anderen Code. Bitte prüfen Sie Name und Wert (ohne Anführungszeichen).",
      "meta_missing": "Auf Ihrer Startseite ist das Meta-Tag noch nicht zu finden. Ist die Änderung gespeichert und ein Cache geleert?",
      "meta_mismatch": "Das Meta-Tag ist da, enthält aber einen anderen Code – vielleicht einen älteren. Bitte den aktuellen Code einsetzen.",
      "file_missing": "Die Datei ist unter dem angegebenen Pfad nicht erreichbar (Fehler 404).",
      "file_mismatch": "Die Datei ist da, enthält aber einen anderen Code.",
      "unreachable": "Ihre Website war bei der Prüfung nicht erreichbar. Bitte später erneut versuchen."
    },
    "guides": {
      "wordpress": {
        "title": "WordPress",
        "steps": [
          "Installieren Sie das Plugin „WPCode – Insert Headers and Footers“ (Plugins → Installieren).",
          "Öffnen Sie Code Snippets → Header & Footer.",
          "Fügen Sie das Meta-Tag im Feld „Header“ ein und speichern Sie.",
          "Leeren Sie einen Cache (z. B. WP Rocket, LiteSpeed), falls vorhanden, und klicken Sie hier auf „Jetzt prüfen“."
        ]
      },
      "jimdo": {
        "title": "Jimdo",
        "steps": [
          "Öffnen Sie Einstellungen → Kopfbereich bearbeiten (Head).",
          "Fügen Sie das Meta-Tag ein und speichern Sie.",
          "Klicken Sie hier auf „Jetzt prüfen“."
        ]
      },
      "ionos": {
        "title": "IONOS",
        "steps": [
          "Melden Sie sich bei IONOS an und öffnen Sie Domains & SSL.",
          "Klicken Sie bei Ihrer Domain auf das Zahnrad → DNS.",
          "Wählen Sie „Record hinzufügen“ → TXT.",
          "Host-Name: den Teil vor Ihrer Domain (z. B. _website-guard-verify), Wert: den Code. Speichern."
        ]
      },
      "strato": {
        "title": "Strato",
        "steps": [
          "Öffnen Sie im Strato-Kundenlogin Domains → Domainverwaltung.",
          "Klicken Sie bei der Domain auf das Zahnrad → DNS → TXT- und CNAME-Records verwalten.",
          "Legen Sie einen TXT-Record mit dem Präfix (z. B. _website-guard-verify) und dem Code als Wert an. Speichern."
        ]
      },
      "allinkl": {
        "title": "All-Inkl",
        "steps": [
          "Öffnen Sie das KAS (kas.all-inkl.com) → Tools → DNS-Einstellungen.",
          "Wählen Sie Ihre Domain → „Neuen DNS-Eintrag erstellen“.",
          "Name: den Teil vor Ihrer Domain (z. B. _website-guard-verify), Typ: TXT, Data: den Code. Speichern."
        ]
      },
      "ftp": {
        "title": "Per FTP",
        "steps": [
          "Verbinden Sie sich per FTP/SFTP mit Ihrem Webspace (Zugangsdaten beim Hoster).",
          "Legen Sie im Hauptverzeichnis der Website den Ordner .well-known an (falls nicht vorhanden).",
          "Erstellen Sie darin die Datei mit dem angegebenen Namen und fügen Sie nur den Code als Inhalt ein."
        ]
      },
      "other": {
        "title": "Anderer Anbieter",
        "steps": [
          "Suchen Sie in der Hilfe Ihres Anbieters nach „TXT-Eintrag“, „Meta-Tag einfügen“ oder „Datei hochladen“.",
          "Kommen Sie nicht weiter? Über „Hilfe anfordern“ richten wir das für Sie ein."
        ]
      }
    }
  },
  "privacy": {
    "export": {
      "title": "Daten exportieren",
      "text": "Sie erhalten alle Daten Ihres Kontos als JSON-Datei: Konto, Mitglieder, Websites, Ausfälle, Probleme und Anfragen. Den Link schicken wir Ihnen per E-Mail.",
      "button": "Export anfordern",
      "sent": "Der Link ist unterwegs. Er ist bis {{date}} gültig.",
      "once": "Sie können einmal pro Tag einen Export anfordern. Der Link aus der letzten E-Mail ist noch gültig."
    },
    "delete": {
      "title": "Konto löschen",
      "text": "Die Überwachung aller Websites wird sofort gestoppt, alle Geräte werden abgemeldet. Nach 30 Tagen löschen wir alle Daten endgültig.",
      "undo": "Bis dahin können Sie die Löschung über den Link in unserer E-Mail rückgängig machen.",
      "button": "Konto löschen …",
      "password": "Zur Bestätigung: Ihr Passwort",
      "confirm": "Konto endgültig löschen",
      "wrongPassword": "Das Passwort stimmt nicht.",
      "subscription": "Bitte kündigen Sie zuerst Ihr Abo (Tarif & Rechnungen → Rechnungen & Zahlungsdaten). Danach können Sie das Konto löschen."
    },
    "deleted": {
      "title": "Ihr Konto wird gelöscht",
      "text": "Die Überwachung ist gestoppt. Am {{date}} löschen wir alle Daten endgültig. Bis dahin können Sie das Konto über den Link in unserer E-Mail wiederherstellen.",
      "textNoDate": "Die Überwachung ist gestoppt. In 30 Tagen löschen wir alle Daten endgültig. Bis dahin können Sie das Konto über den Link in unserer E-Mail wiederherstellen."
    },
    "restore": {
      "title": "Konto wiederherstellen",
      "text": "Ihr Konto und alle Daten sind noch da. Mit einem Klick läuft die Überwachung wieder.",
      "button": "Konto wiederherstellen",
      "done": "Ihr Konto ist wiederhergestellt. Bitte melden Sie sich an."
    },
    "download": {
      "title": "Datenexport herunterladen",
      "text": "Ihr Export ist bereit. Die Datei enthält alle Daten Ihres Kontos im JSON-Format.",
      "button": "Datei herunterladen",
      "done": "Der Download wurde gestartet."
    }
  }
}
